import { CellContext } from '@tanstack/react-table';
import { CompanyCustomBenefitAssignmentEmployee } from '@pxtra-client-lib-legacy/gen';
import { TooltipComponent } from '../../../atomic/feedback';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../../theme';
import { getEditingStatus } from '../utils';

export const EditingStatusCell = ({
  row
}: CellContext<CompanyCustomBenefitAssignmentEmployee, unknown>) => {
  const { t } = useTranslation();
  const editingStatus = getEditingStatus(row.original);

  if (editingStatus === 'unchanged') return null;

  let backgroundColor: string;
  if (editingStatus === 'invalid') {
    backgroundColor = theme.palette.error.main;
  } else if (editingStatus === 'changed') {
    backgroundColor = theme.palette.heaven.main;
  } else {
    backgroundColor = theme.palette.grey[50];
  }

  return (
    <TooltipComponent arrow placement="top" title={t(`custom:${editingStatus}`)}>
      <div
        style={{
          borderRadius: '50%',
          backgroundColor,
          display: 'inline-block',
          width: '8px',
          height: '8px'
        }}
      />
    </TooltipComponent>
  );
};
